export const formatAmount = (amount: number) =>
  window.Intl !== undefined ? new Intl.NumberFormat().format(amount) : String(amount);
